import { ADD_CASE_SUCCESS, ADD_CASE_FAILURE } from "../actions/caseActions";

const initialState={
    loading: true,
    data: [],
    error : ""
}

const CASE = (state=initialState, action)=> { 
    switch(action.type){
        case ADD_CASE_SUCCESS:
            return {
                loading:false,
                data: action.payload,
                error:null
            }
        case ADD_CASE_FAILURE: 
            return{
                loading:false,
                data: [],
                error: action.payload
            }
        default: return state;
    }
}

export default CASE;